import React from 'react'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

const IndexPage = ({ data }) => {
  console.log(data)
  const {edges: config } = data.allConfigYaml

  let profile = config[0].node // TODO: Figure out why this is in an array.

  return (
    <div className="container">
      <div className="content">
        <h1>
          <span className="green">{profile.profileName}</span>, <em className="red">{profile.profileTitle}</em>
        </h1>
        <h2>{profile.profileLocation}</h2>
        <ul className="list-inline">
          <li><OutboundLink href="https://www.github.com/arnoldsandoval">GitHub</OutboundLink></li> 
          <li><span className="orange">{profile.profileTel}</span></li>
        </ul>
      </div>
    </div>
  )
}

export const query = graphql`
  query IndexQuery {
    allConfigYaml {
      edges {
        node {
          profileName
          profileEmail
          profileTel
          profileTitle
          profileLocation
        }
      }
    }
  }
`

export default IndexPage


// WEBPACK FOOTER //
// ./src/pages/index.js